//NEW: UI_REVAMP
import { Box, Divider, Flex, Text, VStack } from '@chakra-ui/react';
import { useBettingList } from '../../hooks/useBettingList';
import ImgComp from '../../utils/ImgComp';

const SimpleBettingList = ({ getGame }) => {
	const { allBetting, removeBetting, categories } = useBettingList(getGame);

	return (
		<Flex flexDirection='column' p={1} bg='#F1F6FF' h='full' borderRadius={8}>
			<Flex flexDirection='column' alignItems='start' px={1}>
				<Flex alignItems='center' gap={2.5}>
					<ImgComp svgName='list' w={2} h={2} />
					<Text fontSize='12px' fontWeight={500} color='#3B3B40'>
						Bet Lists
					</Text>
				</Flex>
				<Text fontSize='10px' fontWeight={500} color='#003198'>
					{allBetting.length} item(s)
				</Text>
			</Flex>

			<Divider borderColor='#457CEE' borderBottomWidth='2px' my={2} />

			<VStack align='stretch' spacing={3} h='full' overflowY='auto' w='full'>
				{allBetting.length === 0 ? (
					<Text fontSize='12px' fontWeight={500} color='#5E5D61' textAlign='center'>
						No bets
					</Text>
				) : (
					categories.map((cat) => {
						const bets = allBetting.filter(
							(b) => b.gameType === cat.gameType && b.betType === cat.betType,
						);

						return (
							<VStack align='stretch' spacing={1} key={`${cat.gameType}-${cat.betType}`} w='full'>
								<Flex gap={1} alignItems='center'>
									<ImgComp svgName={cat.gameType.toLowerCase()} w={5} h={5} />
									<Text fontSize='12px' fontWeight={500} color='#3B3B40'>
										{cat.betType}
									</Text>
								</Flex>
								<Flex flexDirection='column' gap={1} flex={1}>
									{bets.map((bet) => (
										<Flex
											key={bet.id}
											bg='#E2DEFF'
											borderRadius={8}
											px={1}
											py={2}
											alignItems='center'
											w='full'
											justifyContent='space-between'
										>
											<Text
												fontSize='12px'
												fontWeight={700}
												color='#1634F2'
												letterSpacing='1px'
												whiteSpace='nowrap'
											>
												{bet.gameType === 'EZ2' ? bet.digit.replace(/\s+/g, '-') : bet.digit}
											</Text>

											<Flex alignItems='center' justifyContent='flex-end' gap={0.5}>
												{bet.isLuckyPick && <ImgComp svgName='lucky' w={3} h={3} />}
												<Box
													as='button'
													onClick={(e) => {
														e.stopPropagation();
														removeBetting(bet.id);
													}}
													minH={0}
													minW={0}
													w={4}
													h={4}
												>
													<ImgComp svgName='outline-remove' w='full' h='full' />
												</Box>
											</Flex>
										</Flex>
									))}
								</Flex>
							</VStack>
						);
					})
				)}
			</VStack>
		</Flex>
	);
};

export default SimpleBettingList;
